<template>
  <article class="createflow_box" v-if="failureMes">
    <div class="status_icon create_failure"></div>
    <div class="status_title">{{this.failureMes}}</div>
    <footer-btn title="返回" @submit="handleGoBack"></footer-btn>
  </article>
  <article class="create-flow content_process" v-else>
    <div class="content_detail">
      <div class="createflow-car-info" v-if="imageUrl && !isImgError">
        <img :src="imageUrl" alt="" @error="handleSetErrorImg">
        <p class="plate-number"><span class="name">{{ visitsData.plate_number }}</span></p>
      </div>
      <div class="createflow-car-info none-car-pic" v-else>
        <p class="tip-info">{{ isImgError ? '网络错误' : '未抓拍到图片' }}</p>
        <p class="refresh-btn" v-if="isImgError" @click="handleRefreshImg"></p>
        <p class="plate-number"><span class="name">{{ visitsData.plate_number }}</span></p>
      </div>
      <group title="车辆品牌">
        <div class="box">
          <checker
            v-model="brand_id"
            default-item-class="brands-item"
            selected-item-class="brands-item-selected"
            v-if="visitsData && visitsData.brands.length">
            <checker-item
              v-for="(item, index) in visitsData.brands"
              :disabled="!item.is_current_brand && !item.is_self_brand"
              :class="[item.is_current_brand ? 'brands-item-selected' : '', (!item.is_current_brand && !item.is_self_brand) ? 'brands-item-disabled' : '']"
              :value="item.id"
              :key="index"
              @on-item-click="handleOnSelCarBrand(item)"
            >
              {{ item.name }}
            </checker-item>
          </checker>
        </div>
      </group>
      <h2 class="title-bar">
        <span>放行流程</span>
        <label class="temporary-release" v-if="(visitsData.has_workshop_rules && visitsData.has_temporary_rules) || ruleDisabled">
          <input type="checkbox" v-model="hasSelectedTemporaryRule" :disabled="ruleDisabled" @change="handleRuleChange"/>临时放行
        </label>
      </h2>
      <div
        class="change-rule"
        @click="changeRuleStatus"
        v-if="visitsData.exiting_rules.length > 1"
      >{{ ruleTitle }}
      </div>
      <div class="process_list" v-if="visitsData.exiting_rule_steps.length">
        <ul class="flow">
          <li v-for="(item, index) in visitsData.exiting_rule_steps" :key="index">
            <div class="status_icon">
              <i class="status_line"></i>
              <i class="icon" :class="item.step_no === 1 ? 'status_waiting' : 'original' "></i>
            </div>
            <div class="status_info" @click.stop="handleOnSelect(index, item.step_no)">
              <div>
                <p>{{item.step_no === 1 ? '发起人' : '选择审核人'}}</p>
                <p v-for="(v, i) in item.selEmployee" :key="i">{{v.employee_name}}</p>
              </div>
              <div class="arrow_right" v-if="item.step_no !== 1"></div>
            </div>
          </li>
          <li>
            <div class="status_icon">
              <i class="status_line"></i>
              <i class="icon original"></i>
            </div>
            <div class="status_info">
              <p class="title">已出店</p>
            </div>
          </li>
        </ul>
      </div>
      <group title="放行备注（必填）">
        <cell :title="reason.name" @click.native="handleGetReleaseReason" :bdStart="true" is-link></cell>
        <div class="createflow__img">
          <upload-img v-model="imageList" />
        </div>
        <x-textarea v-model.trim="visitsData.note" :max="120" placeholder="补充说明" :show-counter="true" :height="120"></x-textarea>
      </group>
      <!-- 选择审核人弹层 -->
      <popup v-model="showEmployee" style="height: 100%;overflow: auto;">
        <group title="选择审核人">
          <checklist v-model="selEmployeeIds" :options="employeeChoices" label-position="left">
          </checklist>
        </group>
        <toast v-model="selectionAuditor" type="text" :time="1000">至少选择一个审核人</toast>
        <footer-btn title="确定" @submit="handleOnSure"></footer-btn>
      </popup>
      <!-- 选择放行规则弹层 -->
      <popup v-model="showRules" style="height: 100%;overflow: auto;">
        <group :title="visitsData.rule_type_text">
          <div
            class="createflow__rules"
            v-for="item in visitsData.exiting_rules"
            :key="item.rule_id"
            @click="handleRuleClick(item.rule_id)"
          >
            <div style="padding-right:16px;">
              <p class="createflow__rules-name">{{item.rule_name}}</p>
              <p class="createflow__rules-text">{{item.text}}</p>
            </div>
            <input type="radio" v-model="rule_id" :value="item.rule_id" />
          </div>
        </group>
      </popup>
      <!-- 选择放行原因弹层 -->
      <popup v-model="showReasons" style="height: 50%;overflow: auto;">
        <search-input
          v-model="keyword"
          placeholder-word="输入名称快速搜索"
          @input="handleSearchInput"
        />
        <group>
          <cell
            v-for="option in reasonOptions"
            :key="option.id"
            :title="option.name"
            @click.native.capture="handleReasonClick(option)"
          >
            <input type="radio" v-model="reasonId" :value="option.id" />
          </cell>
        </group>
      </popup>
    </div>
    <x-button type="primary" class="footer_btn" @click="handleOnSubmit">{{btnTips}}</x-button>
  </article>
</template>

<script>
import {
  Group,
  Cell,
  XTextarea,
  Checker,
  CheckerItem,
  Popup,
  Checklist,
  XButton,
  Toast
} from '@lx-frontend/cvux'
import FooterBtn from '../components/FooterBtn'
import SearchInput from '../components/SearchInput'
import UploadImg from './UploadImg'

let reasonOptionsCope = []

export default {
  components: {
    Group,
    Cell,
    XTextarea,
    Checker,
    CheckerItem,
    Popup,
    Checklist,
    XButton,
    Toast,
    FooterBtn,
    UploadImg,
    SearchInput
  },
  data() {
    return {
      id: 0,
      selectionAuditor: false,
      stepsIndex: 0,
      showEmployee: false,
      selEmployeeIds: [],
      employeeChoices: [],
      showRules: false,
      isTapDone: false, // 防止重复点击
      failureMes: '', // 失败请求
      visitsData: {
        note: '',
        selCustomer: '',
        exiting_rule_steps: [],
        exiting_rule_id: null,
        exiting_rules: [],
        brands: []
      },
      showReasons: false, // 控制选择放行原因弹窗
      reasonOptions: [],
      reason: {
        id: '',
        name: ''
      },
      reasonId: '',
      queryForm: {
        keyword: ''
      },
      brand_id: '', // 车辆品牌
      rule_id: '', // 规则
      isImgError: false,
      imageUrl: '',
      ruleTitle: '请选择放行规则',
      sucKey: 'barriergate_data_suc', // 发布成功后的sessionKey
      sessionKey: 'barriergate_data', // 进入选择审核人列表的sessionKey
      hasSelectedTemporaryRule: 0, // 是否选择临时放行
      ruleDisabled: false, // 禁用临时放行选择
      imageList: [],
      keyword: ''
    }
  },
  created() {
    this.id = this.$route.params.id
    this.getData()
    this.getExitCategories()
  },
  computed: {
    btnTips() {
      return this.visitsData.exiting_rule_steps.length > 1 ? '提交审核' : '确认放行'
    },
    isSelectedTemporaryRule () {
      return (!this.visitsData.has_workshop_rules && this.visitsData.has_temporary_rules) ? 1 : +this.hasSelectedTemporaryRule
    }
  },
  methods: {
    handleReasonClick(reason) {
      this.reason = reason
      this.reasonId = reason.id
      this.showReasons = false
    },

    handleRuleClick(id) {
      this.rule_id = id
      this.showRules = false
      this.getData()
    },

    handleSearchInput(val) {
      if (val) {
        this.reasonOptions = reasonOptionsCope.filter((reason) => {
          return reason.name.includes(val)
        })
      } else {
        this.reasonOptions = reasonOptionsCope
      }
    },

    handleGetReleaseReason() {
      this.showReasons = true
      this.keyword = ''
      this.reasonOptions = reasonOptionsCope
    },

    // 选择车辆品牌
    handleOnSelCarBrand(item) {
      this.rule_id = ''
      this.brand_id = item.id || ''
      this.getData()
    },

    /**
     * 获取放行备注列表
     */
    async getExitCategories() {
      const { code, data } = await this.$rest.barriergate.getExitCategories()
      if (code === 0) {
        const list = data.exit_categories
        const ids = list.map((item) => item.id)
        const selectIds = (JSON.parse(localStorage.getItem('create_flow_select_reason_ids')) || [])
          .filter((id) => ids.includes(id))

        selectIds.forEach((id) => {
          list.forEach((item, index) => {
            if (item.id === id) {
              list.splice(index, 1)
              list.unshift(item)
            }
          })
        })

        this.reasonOptions = reasonOptionsCope = list
        this.reason = list[0]
        this.reasonId = list[0].id
      }
    },

    async getData() {
      const { code, data = {}, message } = await this.$rest.barriergate.getFlowStep({
        brand_id: +this.brand_id,
        exiting_rule_id: +this.rule_id,
        has_selected_temporary_rule: this.isSelectedTemporaryRule
      }, `${this.id}/exiting/process/start`)
      if (code === 0) {
        this.imageUrl = data.image_url

        // 当车辆已经进入车间且当前操作人不是车间规则发起人，仅是临时放行规则发起人时页面显示临时放行勾选框，且默认勾上不可编辑
        if (!data.has_workshop_rules && data.has_temporary_rules) {
          this.hasSelectedTemporaryRule = 1
          this.ruleDisabled = true
        }

        this.ruleTitle = data.exiting_rule_steps.length ? '更换放行规则' : '请选择放行规则'

        data.brands.forEach(item => {
          if (item.is_current_brand && !this.brand_id) {
            this.brand_id = item.id
          }
        })

        if (data.exiting_rules.length === 1) {
          this.rule_id = data.exiting_rules[0].rule_id
        }

        data.exiting_rule_steps.forEach(v => {
          v.selEmployee = []
          v.selEmployeeIds = []
        })

        if (data.exiting_rule_steps[0]) {
          // 发起人默认选中
          const firstOne = data.exiting_rule_steps[0].review_employee_choices
          data.exiting_rule_steps[0].selEmployee = firstOne
          data.exiting_rule_steps[0].selEmployeeIds = [firstOne[0].employee_id]
        }

        data.note = ''
        this.visitsData = data
      } else {
        this.failureMes = message
      }
    },
    /**
     * @description: 选择是否临时放行，需更换规则，重置 rule_id。
     * 本次修复因切换临时放行未重置 rule_id 而导致提交时 steps 为 []，后端报接口校验错误的问题
     * @return {*}
     */
    handleRuleChange() {
      this.rule_id = ''
      this.getData()
    },
    // 选择审核人
    handleOnSelect(index, stepNo) {
      if (stepNo !== 1) {
        let list = []
        let employeeList = this.visitsData['exiting_rule_steps'][index]['review_employee_choices']
        employeeList.forEach(v => {
          list.push({
            key: +v.employee_id,
            value: v.employee_name
          })
        })
        this.stepsIndex = index
        this.employeeChoices = list
        this.selEmployeeIds = this.visitsData['exiting_rule_steps'][index]['selEmployeeIds']
        this.showEmployee = true
      }
    },
    // 确定选择审核人
    handleOnSure() {
      if (this.selEmployeeIds.length) {
        let ruleSteps = this.visitsData['exiting_rule_steps'][this.stepsIndex]
        if (ruleSteps) {
          let employeeList = ruleSteps.review_employee_choices
          ruleSteps['selEmployee'] = employeeList.filter(v => {
            return this.selEmployeeIds.indexOf(v.employee_id) > -1
          })
          ruleSteps['selEmployeeIds'] = this.selEmployeeIds
        }
        this.showEmployee = false
      } else {
        this.selectionAuditor = true
      }
    },

    // 提交审核
    async handleOnSubmit() {
      // let nParams = {}
      let params = {}
      if (this.isTapDone) {
        return false
      }

      params.visit_id = +this.visitsData.visit_id
      params.exiting_rule_id = +this.rule_id
      params.customer_id = this.visitsData.customer_choices ? +this.visitsData.selCustomer : null
      // params.customer_id = this.visitsData.selCustomer
      params.steps = []
      params.brand_id = +this.brand_id
      params.exit_category_id = +this.reasonId

      // 是否选择放行规则
      if (!params.exiting_rule_id) {
        this.showToast(`请选择放行规则`)
        return
      }
      // 步骤列表检查
      let noReviewer = this.visitsData.exiting_rule_steps.find((v, index) => {
        return (index > 0) && (!v.selEmployee || v.selEmployee.length === 0)
      })
      if (noReviewer) {
        this.showToast(`${noReviewer.title}缺少审核人`)
        return false
      }

      // 拼接表单
      this.visitsData.exiting_rule_steps.forEach(item => {
        let step = {}
        step.rule_step_id = +item.step_id
        step.step_no = +item.step_no
        step.title = item.title
        step.review_employee_ids = item.selEmployeeIds
        params.steps.push(step)
      })

      params.remark = this.visitsData.note
      params.has_selected_temporary_rule = +this.isSelectedTemporaryRule

      this.isTapDone = true
      this.switchLoading({ status: true, text: '加载中...' })

      // 上传图片
      if (this.imageList.length) {
        const mediaIds = await Promise.all(this.imageList.map((localId) => {
          return new Promise((resolve) => {
            this.$wechat.wx.uploadImage({
              isShowProgressTips: 0,
              localId,
              success: (res) => resolve(res.serverId),
              fail: () => {
                this.switchLoading({ status: false })
                this.showToast('图片上传失败，请稍后重试')
                this.isTapDone = false
              }
            })
          })
        }))

        const { code, data, message } = await this.$rest.barriergate.uploadWorkflowImages({ media_ids: mediaIds })
        if (code === 0) {
          params.image_urls = JSON.stringify(data.map(item => item.upload_image))
          this.submit(params)
        } else {
          this.switchLoading({ status: false })
          this.showToast(message || '网络异常，请稍后重试')
          this.isTapDone = false
        }
      } else {
        this.submit(params)
      }
    },

    async submit(params) {
      const { code, message } = await this.$rest.barriergate.createFlow(params, `${this.id}/exiting/process/start?brand_id=${this.brand_id}`)

      this.switchLoading({ status: false })
      this.isTapDone = false

      if (code === 0) {
        // 选择的放行备注保存到 storage
        let selectReasonList = JSON.parse(localStorage.getItem('create_flow_select_reason_ids')) || []
        if (selectReasonList.includes(this.reasonId)) {
          selectReasonList.splice(selectReasonList.indexOf(this.reasonId), 1)
        }
        selectReasonList.push(this.reasonId)
        selectReasonList = selectReasonList.slice(-3)
        localStorage.setItem('create_flow_select_reason_ids', JSON.stringify(selectReasonList))

        // 跳转到成功页面
        this.$router.push(`/barriergate/create/succ/${this.sucKey}`)
      } else {
        this.showToast(message)
      }
    },
    handleGoBack() {
      this.$router.go(-1)
    },
    // 选择放行规则列表项
    handleSelectedRule (val) {
      this.showRules = false
      this.rule_id = val
      this.getData()
    },
    // 选择请选择放行规则或更换放行规则,显示放行规则列表
    changeRuleStatus () {
      this.showRules = true
    },
    handleSetErrorImg () {
      this.isImgError = true
    },
    handleRefreshImg () {
      this.imageUrl = this.visitsData.image_url
      this.isImgError = false
    }
  }
}

</script>
<style lang="less">
@import "../../stylesheets/modules/barriergate/creatFlow.less";
@import "../../stylesheets/modules/components/flow.less";
</style>
